import React from "react";

import { Eye } from "../../FundForm/icons";
import {
  formatDateRange,
  humanise,
  planTypeName,
  TSavedFund,
} from "../previewFund";
import styles from "../previewFund.module.scss";

interface IGlanceStrip {
  fund: TSavedFund;
  isVisible: boolean;
}

/** The four facts that decide what a fund is, before any scrolling. */
export default function GlanceStrip({ fund, isVisible }: IGlanceStrip) {
  const planType = planTypeName(fund);
  const depositTypes = Array.from(
    new Set(
      (fund.investment_product_details ?? [])
        .map((detail) => humanise(detail.deposit_type))
        .filter(Boolean),
    ),
  );

  return (
    // A div, not a section: the app's global stylesheet forces every
    // <section> to `display: inline-block !important`, which kills the grid.
    <div role="group" aria-label="At a glance" className={styles.glance}>
      <div className={styles.glanceCell}>
        <div className={styles.glanceLabel}>Plan type</div>
        {planType ? (
          <div className={styles.chip}>{planType}</div>
        ) : (
          <div className={styles.glanceValue}>Not a savings plan</div>
        )}
      </div>

      <div className={styles.glanceCell}>
        <div className={styles.glanceLabel}>Deposit type</div>
        <div className={styles.glanceValue}>
          {depositTypes.join(" · ") || "Not set"}
        </div>
      </div>

      <div className={styles.glanceCell}>
        <div className={styles.glanceLabel}>Subscriptions</div>
        <div className={styles.glanceValue}>
          {formatDateRange(fund.start_date, fund.end_date) ?? "Not set"}
        </div>
      </div>

      <div className={styles.glanceCell}>
        <div className={styles.glanceLabel}>Visibility</div>
        <div
          className={`${styles.chipOk} ${isVisible ? "" : styles.chipMuted}`}
        >
          <Eye size={14} />
          {isVisible ? "Visible to customers" : "Hidden from customers"}
        </div>
      </div>
    </div>
  );
}
